// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 53 ? "webfontloader" : chunkId) + "." + {"53":"6e80cfaf","658":"28108122","845":"56920fb3","982":"ce9667b0"}[chunkId] + ".js";
};